/* Publish by EComposer at 2025-08-10 08:25:49*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-3klyi9s43gr"]=  window.__ectimmers["ecom-3klyi9s43gr"] || {};
if(this.settings.layout==="slider"){let i=this.$el,t="bullets";if(this.settings.slider_pagination_style==="progress"&&(t="progressbar"),!i)return;let o=i.querySelector(".ecom-shopify__blog-container"),s=o&&o.dataset.optionSwiper;s=JSON.parse(s),s.pagination={el:i.querySelector(".ecom-swiper-pagination"),type:t,clickable:!0},s.navigation={nextEl:i.querySelector(".ecom-swiper-button-next"),prevEl:i.querySelector(".ecom-swiper-button-prev")},new window.EComSwiper(o,s)}if(this.settings.use_ajax&&this.isLive){const i=this.$el;if(!i)return;const t=i.querySelector(".ecom-shopify__blog-wrapper"),o=function(e){e.preventDefault();const a=this.dataset.get,n=this.closest(".ecom-sections[data-section-id]");if(!a||!n||!n.dataset.sectionId)return;const p=n.dataset.sectionId,_=`${a}&section_id=${p}`;c(_,n),t.scrollIntoView()};i.querySelectorAll(".ecom-pagination-item").forEach(e=>{e.addEventListener("click",o)});const c=function(e,a){const n=async function(p){return(await fetch(p,{method:"GET",cache:"no-cache",headers:{"Content-Type":"text/html"}})).text()};a.classList.add("ecom-doing-load-blog"),n(e).then(function(p){i.querySelectorAll(".ecom-shopify__blog--post").forEach(function(u){u.remove()});const d=document.createElement("div");d.innerHTML=p;const r=d.querySelector(".ecom-shopify__blog--posts");if(!r)return;const y=a.querySelector(".ecom-shopify__blog--posts"),$=a.querySelector(".ecom-pagination-navigation.ecom-collection__pagination-navigation");for(;r.firstChild;)y.appendChild(r.firstChild);r.parentNode.removeChild(r);const h=d.querySelector(".ecom-pagination-navigation.ecom-collection__pagination-navigation");h&&($.innerHTML=h.innerHTML,i.querySelectorAll(".ecom-pagination-item").forEach(v=>{v.addEventListener("click",o)}))}).finally(function(){a.classList.remove("ecom-doing-load-blog")})}}

                    });
                    
                        document.querySelectorAll('.ecom-3klyi9s43gr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3klyi9s43gr', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ou8ikfii07i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ou8ikfii07i', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-07p72zi4gimj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-07p72zi4gimj', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2mxuj1kuxch').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2mxuj1kuxch', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jxvjdoaf1bm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jxvjdoaf1bm', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z2dkxkpa55').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z2dkxkpa55', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f2sm75ssz6r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f2sm75ssz6r', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dxs6m17da58').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dxs6m17da58', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0peq5ga07vud').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0peq5ga07vud', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-53nv88zkhu5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-53nv88zkhu5', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ktztmlvkpl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ktztmlvkpl', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-spyb201edb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-spyb201edb', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m6k6qrpywbo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m6k6qrpywbo', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iigc771bymk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iigc771bymk', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f16djmsfqz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f16djmsfqz', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1jjjlii6ta8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1jjjlii6ta8', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5gvbpfnyau').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5gvbpfnyau', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-buw93lef8sc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-buw93lef8sc', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cc2mu2b1z5k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cc2mu2b1z5k', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-69o2echuv4x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-69o2echuv4x', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eblpan0k8mn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eblpan0k8mn', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-elkc75w277j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-elkc75w277j', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mkodrty355c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mkodrty355c', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-69ls5o5ix4k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-69ls5o5ix4k', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-78t0s2opvam').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-78t0s2opvam', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y6erveg4wu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y6erveg4wu', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-btgsfkam5xf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-btgsfkam5xf', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-33r1bozphb8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-33r1bozphb8', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ubr9lipkyqh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ubr9lipkyqh', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vgzmjosb9z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vgzmjosb9z', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7b9ba1l7zjy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7b9ba1l7zjy', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8b3h5zxlyq7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8b3h5zxlyq7', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uje1z6x1v6c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uje1z6x1v6c', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gqdb1e12dgs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gqdb1e12dgs', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7weu30emrpd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7weu30emrpd', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9xoju9asj4q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9xoju9asj4q', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6w0ty7yt0hd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6w0ty7yt0hd', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-peeiqttnetn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-peeiqttnetn', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-of32zf74q6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-of32zf74q6', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-32b4m07jkrr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-32b4m07jkrr', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fdpbmapn9cu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fdpbmapn9cu', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-laauwu79dcn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-laauwu79dcn', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-59al3iya38m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-59al3iya38m', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w8go8knvxk8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w8go8knvxk8', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tr9d3udisv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tr9d3udisv', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h2vpan97y7e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h2vpan97y7e', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3rbcmilw8ew').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3rbcmilw8ew', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vw1tu7oqzl9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vw1tu7oqzl9', settings: {"layout":"grid"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}